var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tw-text-grey-600"},[(_vm.wrapped)?[_vm._v("(")]:_vm._e(),_vm._v(_vm._s(_vm.pricePerUnit.value)+"/"+_vm._s(_vm.pricePerUnit.label)),(_vm.wrapped)?[_vm._v(")")]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }